import React from "react";
import RobotImg from "../../Assets/partnerRobot.png";
import { FiArrowRight } from "react-icons/fi";

const PartnerBanner = () => {
  return (
    <div className="md:pt-4 lg:pt-12 pb-4 sm:pb-6 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 bg-white overflow-visible">
      <div className="max-w-screen-2xl mx-auto relative">
        <div className="w-full h-auto bg-gradient-to-r from-brandOrange via-[#7B61FF] to-brandBlue rounded-xl flex items-center relative overflow-hidden">
          <div
            className="absolute inset-0 opacity-20"
            style={{
              backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
              backgroundSize: "40px 40px",
            }}
          ></div>

          <div className="container p-4 sm:px-10 lg:p-8 flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6 relative z-10">
            {/* Center Text */}
            <div className="flex-1 text-center md:text-left md:ml-36 lg:ml-48">
              <h2 className="text-2xl font-extrabold text-white leading-tight">
                Your Partner in <br className="hidden md:block" />
                Intelligent Automation
              </h2>
            </div>

            {/* Right side CTA */}
            <div className="flex items-center gap-2 shrink-0">
              <button className="bg-white text-brandDark px-8 py-4 rounded-full font-bold text-sm md:text-base hover:bg-gray-100 transition-colors uppercase tracking-wider">
                Get In Touch
              </button>
              <div className="w-12 h-12 md:w-14 md:h-14 bg-white rounded-full flex items-center justify-center text-brandDark">
                <FiArrowRight size={24} />
              </div>
            </div>
          </div>
        </div>

        {/* Overlapping Robot Imagery */}
        <div className="absolute hidden md:flex md:-top-14 lg:-top-20 md:left-2 lg:left-4 h-[148px] sm:h-[178px] lg:h-[205px] pointer-events-none z-20">
          <img
            src={RobotImg}
            alt="AI Partner Robots"
            className="w-full h-auto drop-shadow-2xl"
          />
        </div>
      </div>
    </div>
  );
};

export default PartnerBanner;
